import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, isAdmin, loading, userLoading, firebaseUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || userLoading) return;

    // No Firebase session — definitely not authenticated
    if (!firebaseUser) {
      navigate('/login', { replace: true });
      return;
    }

    // Firebase session exists but DB user not loaded yet — wait
    if (!user) return;

    if (!isAdmin) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, isAdmin, loading, userLoading, firebaseUser, navigate]);

  // Show loading while Firebase auth, DB user fetch, or the brief gap between them is in progress
  if (loading || userLoading || (firebaseUser && !user)) {
    return (
      <div className="min-h-screen bg-dark-950 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500 mb-4"></div>
          <p className="text-white text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return null;
  }

  return <>{children}</>;
};

export default AdminRoute;
